import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { PatientListService } from 'src/app/clinical/dashboards/patient-list/patient-list.service';
import { Patient } from 'src/app/models/patient.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-patient-autocomplete',
  templateUrl: './search-patient.component.html',
  styleUrls: ['./search-patient.component.scss'],
})
export class SearchPatientComponent implements OnInit, OnChanges {
  @Output() patientSelected = new EventEmitter<Patient>();
  @Output() noSelectedOption = new EventEmitter<boolean>();
  @Input() searchInput: UntypedFormControl = new UntypedFormControl();
  @Input() searchModel: any = { appearance: 'legacy', showLabel: false };
  filteredOptions$: Observable<any[]>;
  searchMax = 15;
  constructor(private patientService: PatientListService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchInput && !changes.searchInput?.firstChange) {
      this.setFilteredOptionToSearch();
    }
  }

  ngOnInit(): void {
    this.setFilteredOptionToSearch();
  }
  emitSelectedPatient(patient: Patient) {
    this.patientSelected.emit(patient);
  }

  getOptionText(option) {
    return option ? `${option.firstName} ${option.lastName}` : '';
  }

  handleImageError(event: any): void {
    event.target.src = environment.defaultPhotoUrl ?? '';
  }

  protected setFilteredOptionToSearch(): void {
    this.filteredOptions$ = this.searchInput.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value: string) => {
        // Clear results if input is empty
        if (!value || value.length === 0) {
          return of([]);
        }
        return this.patientService.filterPatientsFromElasticSearch(
          this.searchMax,
          {
            fullname: value,
            email: value,
            sms_contact: value,
            phone: value,
            devices: value,
            primaryContact: value,
            emr_data: {
              emr_guid: value,
              mrn: value,
            },
          },
          { page: 1 },
          true
        );
      }),
      catchError((error) => {
        console.error('Search error:', error);
        return of([]);
      }),
      map((result: any) => result?.items || [])
    );
  }
}
